

import CardServices from "../cardServices";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import RegisterAccess from '../../../utils/registerAccess';
import HeaderGestorConfigs from "../../../utils/headerGestorConfigs";
// import { useSelector } from 'react-redux';

interface MenuState {
  analise: number;
  chefeArea: number;
  chefeDepartamento: number;
  directoraGeralAdjunta: number;
  directorGeral: number;

  // solicitacoesImportacao: number;
  // analisado: number;
  // deferido: number;
  certificadosEmitidos: number;
  reprovado: number;
  reclamacoes: number;
}
type MenuProps = {
  children?: React.ReactNode
}

export default function MenuImportacao({ children }: MenuProps) {
  // const user = useSelector(state => state.account.user);

  const [menu, setMenu] = useState<MenuState>({
    analise: 0,
    chefeArea: 0,
    chefeDepartamento: 0,
    directoraGeralAdjunta: 0,
    directorGeral: 0,

    // solicitacoesImportacao: 0,
    // analisado: 0,
    // deferido: 0,
    reclamacoes: 0,
    certificadosEmitidos: 0,
    reprovado: 0,
  })
  const [loadMenu, setLoadMenu] = useState<boolean>(true)

  useEffect(() => {
    api.get(`/menu/dmts`)
      .then(response => {
        setMenu(response.data);
      }).catch(error => {

      }).finally(() => setLoadMenu(false))

  }, [])

  return (
    <div className="tw-w-full">
      <RegisterAccess page={'menu importação'} />

      <div className="tw-flex tw-flex-wrap tw-items-start tw-gap-7 tw-px-5 tw-py-4">
        <CardServices funcao='Técnico' load={loadMenu} count={menu.analise} icone={'/icones/Import_export.svg'} nomeService={'Solicitaçōes de Importaçao '} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Não Controlados/Análise'} />
        <CardServices funcao='Técnico' load={loadMenu} count={menu.reprovado} icone={'/icones/solictacoesReprovadas.svg'} nomeService={'Solicitaçōes Reprovadas '} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Não Controlados/Reprovado'} />
      </div>

      <div className="tw-flex tw-flex-wrap tw-items-start tw-gap-7 tw-px-5 tw-py-4">
        <CardServices load={loadMenu} count={menu.chefeArea} icone={'/icones/chefedaSeccao.svg'} nomeService={'Chefe de Área'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Não Controlados/Chefe de Área'} />
        <CardServices funcao='Chefe de Departamento' load={loadMenu} count={menu.chefeDepartamento} icone={'/icones/chefeDepartamento.svg'} nomeService={'Chefe de Departamento'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Não Controlados/Chefe de Departamento'} />
        <CardServices load={loadMenu} count={menu.directoraGeralAdjunta} icone={'/icones/chefedaSeccao.svg'} nomeService={'Directora Geral Adjunta Servicos Executivos'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Não Controlados/Directora Geral Adjunta para os Serviços Executivos'} />
        <CardServices funcao='' load={loadMenu} count={menu.directorGeral} icone={'/icones/diretoraGeral.svg'} nomeService={'Diretor(a) Geral'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Não Controlados/Director Geral'} />
        <CardServices funcao='' load={loadMenu} count={menu.certificadosEmitidos} icone={'/icones/controleQualidade/certificadosAutorizacoes.svg'} nomeService={'Autorizações Emitidas'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Não Controlados/Aprovado'} />
      </div>

      <div className="tw-flex tw-items-center tw-gap-2 tw-px-5 tw-pt-3 tw-pb-1 tw-border-t tw-border-gray-100">
        <div className="tw-w-0.5 tw-h-4 tw-bg-[#85287e]/40 tw-rounded-full" />
        <span className="tw-text-[11px] tw-font-semibold tw-tracking-widest tw-text-gray-400 tw-uppercase">Outros Serviços</span>
      </div>
      <div className="tw-flex tw-flex-wrap tw-items-start tw-gap-7 tw-px-5 tw-py-4">
      {children}

      </div>
    </div>
  )
}

